import EmployeePerformanceTrainingComponents from "../components/EmployeePerformanceTraining";
import useEmployeePerformanceTraining from "../hooks/useEmployeePerformanceTraining";

function EmployeePerformanceTraining() {
  const employeePerformanceTrainingProps = useEmployeePerformanceTraining();
  return (
    <EmployeePerformanceTrainingComponents
      {...employeePerformanceTrainingProps}
    />
  );
}

export default EmployeePerformanceTraining;
